enum RestEndpointsEnum {
    AdminLogin = "/admin/login",
    AdminHeartbeat = "/admin/heartbeat",
    Health = "/health",
    Diagnostics = "/diagnostics",
    AdminCreateTicket = `/createTicket`,
    AdminWebhookTest = `/webhookTest`,
    AmazonOauthRedirect = "/amazon/oauth-redirect",
    AmazonFinalOauthRedirect = "/amazon/oauth-final-redirect",
    AppIosMinVersion = "/app/iosMinVersion",
    AppAndroidMinVersion = "/app/androidMinVersion",
    AppOwOnlineMinVersion = "/app/owOnline/minVersion",
    AwsLambdaImageProcessed = "/aws/lambdaImageProcessed",
    AwsLambdaImageProcessError = "/aws/lambdaImageProcessError",
    BrandedLogin = "/branded-login/",
    CatalogGetItems = "/v1/:catalogGuid/catalogItems/",
    CatalogGetItemsAlias = "/v1/catalog/:catalogGuid/catalog_items/",
    CatalogGetItem = "/v1/catalog/:catalogGuid/catalog_items/:catalogItemGuid",
    CatalogGetItemsByBatch = "/v1/catalog/:catalogGuid/catalog_items/batch",
    CatalogTypeaheadItems = "/v1/catalog/:catalogGuid/catalog_items/typeahead",
    CatalogLookupItemBySku = "/v1/catalog_items/sku-lookup",
    CatalogItemImagesUrlCsvTemplate = "/v1/catalog_items/image-urls-csv-template",
    CatalogsGetCatalogs = "/v1/catalogs/",
    CatalogsGetCatalogsUI = "/catalogs/",
    StripeWebhook = "/stripe-webhook/",
    StripeSupplierWebhook = "/stripe-supplier-webhook/:supplierGuid",
    StripeCompleteCheckout = "/stripe-complete-checkout/:cart_guid",
    VendorGetVendors = "/vendors",
    VendorsCreate = VendorGetVendors,
    VendorSubmitVendorIntakeForm = "/v1/account_intake_form",
    VendorsGetById = "/v1/vendors/:vendorGuid",
    VendorsUpdate = VendorsGetById,
    DailyRoutes = "/v1/daily_routes/",
    DailyRoute = "/v1/daily_routes/:dailyRouteGuid",
    DailyRouteCSV = "/v1/daily_routes/:dailyRouteGuid/csv",
    DailyRoutePayments = "/v1/daily_routes/:dailyRouteGuid/payments",
    DailyRouteTransfers = "/v1/daily_routes/:dailyRouteGuid/transfers",
    DailyRouteDeliveryMatrix = "/v1/daily_routes/delivery-matrix",
    // Daily Route Driver Endpoints (Enroute App)
    DailyRouteStatus = "/v1/daily_routes/:dailyRouteGuid/status",
    DailyRouteReoptimize = "/v1/daily_routes/:dailyRouteGuid/reoptimize",
    DailyRouteStopStatus = "/v1/daily_routes/:dailyRouteGuid/stops/:orderId/status",
    DailyRouteStopDetails = "/v1/daily_routes/:dailyRouteGuid/stops/:orderId",
    DailyRouteSync = "/v1/daily_routes/:dailyRouteGuid/sync",
    GetOrders = `/v1/orders`,
    GetOrder = `/v1/orders/:orderGuid`,
    GetOrderByGuid = `/v1/orders/confirm/:orderGuid`,
    GetOrdersWithAuth = `/v1/orders/list`,
    GetOrderReadOnlyStatus = `/v1/orders/:orderGuid/readonly-status`,
    UpdateOrder = GetOrder,
    CreateOrder = `/v1/order`,
    CreateOrderV2 = `/v2/order`,
    CreateOrderWithItems = `/v1/orderWithItems`,
    SubmitOrder = "/v1/order/submit",
    DeallocateOrderInventory = "/v1/orders/:orderGuid/deallocate-inventory",
    DeallocateOrderInventoryBulk = "/v1/orders/deallocate-inventory",
    ResendCustomMessage = "/v1/orders/:orderGuid/resend-custom-message",
    ShippoWebhook = "/shippo/webhook",
    StripeSupplierVendorSetupIntentComplete = `/stripe-supplier-vendor-setup-intent-complete`,
    AdminFixOrders = `/admin/fixOrders`,
    AdminGetOrderToEmails = `/admin/order/:orderGuid/toEmails`,
    AdminResetDemoData = `/admin/demo/reset`,
    AdminRestoreDemoData = `/admin/demo/restore`,
    AdminResetDemoRoutes = `/admin/demo/reset-routes`,
    AdminProvisionDemoSupplier = `/admin/demo/provision`,
    AdminDeprovisionDemoSupplier = `/admin/demo/deprovision`,
    AdminEnableCatchwerks = `/admin/suppliers/:supplierId/catchwerks/enable`,
    AdminRotateCatchwerksCredentials = `/admin/suppliers/:supplierId/catchwerks/rotate-credentials`,
    AdminCatchwerksRetryRefill = `/admin/suppliers/:supplierId/catchwerks/billing/retry-refill`,
    AdminCatchwerksBillingStatus = `/admin/suppliers/:supplierId/catchwerks/billing/status`,
    InventoryStatus = "/v1/inventory/:catalogItemGuid/status",
    InventoryAllocateHeld = "/v1/inventory/:catalogItemGuid/allocate-held",
    InventoryReleaseHeld = "/v1/inventory/:catalogItemGuid/release-held",
    InventoryFulfillBackorders = "/v1/inventory/:catalogItemGuid/fulfill-backorders",
    InventoryFulfillBackordersByOrder = "/v1/inventory/fulfill-backorders-by-order",
    InventoryBackorderAnalysis = "/v1/inventory/backorder-analysis/:catalogGuid",
    InventoryBackorderAnalysisByOrder = "/v1/inventory/backorder-analysis-by-order/:catalogGuid",
    InventoryAudit = "/v1/inventory/audit",
    InventoryAuditFix = "/v1/inventory/audit/fix",
    InventoryReservedOrders = "/v1/inventory/:catalogItemGuid/reserved-orders",
    InventoryReservedOrdersCsv = "/v1/inventory/:catalogItemGuid/reserved-orders/csv",
    InventoryBackorderedOrders = "/v1/inventory/:catalogItemGuid/backordered-orders",
    InventoryBackorderedOrdersCsv = "/v1/inventory/:catalogItemGuid/backordered-orders/csv",
    InventoryIncomingPurchaseOrders = "/v1/inventory/:catalogItemGuid/incoming-purchase-orders",
    InventoryIncomingPurchaseOrdersCsv = "/v1/inventory/:catalogItemGuid/incoming-purchase-orders/csv",
    InventoryInProduction = "/v1/inventory/:catalogItemGuid/in-production",
    InventoryInProductionAllocation = "/v1/inventory/:catalogItemGuid/in-production/allocation",
    InventorySingleOrderBackorderAnalysis = "/v1/inventory/orders/:orderGuid/backorder-analysis",
    InventoryByCustomer = "/v1/inventory/by-customer/:vendorGuid",
    InventoryByCustomerCsv = "/v1/inventory/by-customer/:vendorGuid/csv",
    InventoryReset = "/v1/inventory/reset",
    GetRmas = "/v1/rmas",
    CreateRma = GetRmas,
    GetRma = "/v1/rmas/:rmaGuid",
    UpdateRma = GetRma,
    DeleteRma = GetRma,
    AuthorizeRma = "/v1/rmas/:rmaGuid/authorize",
    ReceiveRma = "/v1/rmas/:rmaGuid/receive",
    ProcessRma = "/v1/rmas/:rmaGuid/process",
    CancelRma = "/v1/rmas/:rmaGuid/cancel",
    RecordInspection = "/v1/rmas/:rmaGuid/line-items/:lineItemGuid/inspect",
    UpdateInspection = "/v1/rmas/:rmaGuid/line-items/:lineItemGuid/inspections/:inspectionGuid",
    DeleteInspection = UpdateInspection,
    GetInspectionSummary = "/v1/rmas/:rmaGuid/inspection-summary",
    ReportsUpdateReport = "/v1/reports/:reportGuid",
    ReportsDownloadExcelReport = "/v1/reports/:reportGuid/excel",
    ScheduledReportsList = "/v1/scheduled-reports",
    ScheduledReportsCreate = ScheduledReportsList,
    ScheduledReportsGet = "/v1/scheduled-reports/:guid",
    ScheduledReportsUpdate = ScheduledReportsGet,
    ScheduledReportsDelete = ScheduledReportsGet,
    ScheduledReportsToggle = "/v1/scheduled-reports/:guid/toggle",
    ScheduledReportsRunNow = "/v1/scheduled-reports/:guid/run-now",
    AccountNotesGetAll = "/v1/account-notes",
    AccountNotesGetById = "/v1/account-notes/:id",
    AccountNotesCreate = AccountNotesGetAll,
    AccountNotesUpdate = AccountNotesGetById,
    AccountNotesDelete = AccountNotesGetById,
    AccountNotesCsvTemplate = "/v1/account-notes/csv-template",
    SerialsGetAll = "/v1/serials",
    SerialsCsvTemplate = "/v1/serials/csv-template",
    SerialsBulkAssign = "/v1/serials/bulk-assign",
    SerialsBulkCreate = "/v1/serials/bulk-create",
    SerialsProcessSerial = "/v1/serials/process",
    ContactsGetAll = "/v1/contacts",
    ContactsGetById = "/v1/contacts/:contactGuid",
    ContactsCreate = ContactsGetAll,
    ContactsUpdate = ContactsGetById,
    ContactsDelete = ContactsGetById,
    OrderEntryGetAccountItems = "/v1/order-entry/account-items",
    OrderEntryGetItems = "/v1/order-entry/orders/:orderGuid/items",
    OrderEntryDuplicateItem = "/v1/order-entry/orders/:orderGuid/items/:orderEntryItemGuid/duplicate",
    OrderEntryBulkManualPrice = "/v1/order-entry/orders/:orderGuid/items/bulk-manual-price",
    QBDCustomFieldDefinitions = "/v1/qbd/custom-field-definitions",

    // Users
    UserLogin = "/login",
    UserLogout = "/logout",
    FtpLogin = "/ftpLogin",
    UserCreateTicket = "/user/createTicket",
    UserLoadUser = "/user/load_user",
    UserChangePassword = "/user/change-password",
    UserPreferences = "/user/preferences",

    // Purchase Orders
    GetPurchaseOrders = "/v1/purchase-orders",
    CreatePurchaseOrder = GetPurchaseOrders,
    GetPurchaseOrder = "/v1/purchase-orders/:purchaseOrderGuid",
    UpdatePurchaseOrder = GetPurchaseOrder,
    DeletePurchaseOrder = GetPurchaseOrder,
    SendPurchaseOrder = "/v1/purchase-orders/:purchaseOrderGuid/send",
    DownloadPurchaseOrderPdf = "/v1/purchase-orders/:purchaseOrderGuid/pdf",
    AutoPopulatePurchaseOrder = "/v1/purchase-orders/:purchaseOrderGuid/auto-populate",
    GetPurchaseOrderDetailForOrder = "/v1/purchase-orders/order/:orderGuid/details",
    CreatePurchaseOrdersFromOrder = "/v1/purchase-orders/from-order",

    // Purchase Order Items
    GetPurchaseOrderItems = "/v1/purchase-orders/:purchaseOrderGuid/items",
    CreatePurchaseOrderItem = GetPurchaseOrderItems,
    UpdatePurchaseOrderItem = "/v1/purchase-orders/:purchaseOrderGuid/items/:itemGuid",
    DeletePurchaseOrderItem = UpdatePurchaseOrderItem,

    // Vendor Sources
    GetVendorSources = "/v1/vendor-sources",
    CreateVendorSource = GetVendorSources,
    GetVendorSource = "/v1/vendor-sources/:vendorSourceGuid",
    UpdateVendorSource = GetVendorSource,
    DeleteVendorSource = GetVendorSource,
    GetVendorSourcesByCategory = "/v1/vendor-sources/by-category",
    GetCatalogItemVendorSources = "/v1/vendor-sources/catalog-item/:catalogItemGuid",
    GetVendorSourcesForOrderItems = "/v1/vendor-sources/order-items",
    GetVendorSourcesCSV = "/v1/vendor-sources/csv",
    ImportVendorSourcesCSV = "/v1/vendor-sources/csv/import",

    // Vendor Source Locations
    GetVendorSourceLocations = "/v1/vendor-sources/:vendorSourceGuid/locations",
    GetVendorSourceLocation = "/v1/vendor-sources/:vendorSourceGuid/locations/:locationGuid",
    CreateVendorSourceLocation = GetVendorSourceLocations,
    UpdateVendorSourceLocation = GetVendorSourceLocation,
    DeleteVendorSourceLocation = GetVendorSourceLocation,
    GetVendorSourceLocationItemsByCategory = "/v1/vendor-source-locations/by-category",
    GetVendorSourceLocationsCSV = "/v1/vendor-source-locations/csv",
    ImportVendorSourceLocationsCSV = "/v1/vendor-source-locations/csv/import",

    // Vendor Source Catalog Items
    GetVendorSourceCatalogItems = "/v1/vendor-sources/:vendorSourceGuid/catalog-items",
    CreateVendorSourceCatalogItem = GetVendorSourceCatalogItems,
    UpdateVendorSourceCatalogItem = "/v1/vendor-sources/:vendorSourceGuid/catalog-items/:catalogItemGuid",
    DeleteVendorSourceCatalogItem = UpdateVendorSourceCatalogItem,
    GetVendorSourceCatalogItemsCSV = "/v1/vendor-source-catalog-items/csv",
    ImportVendorSourceCatalogItemsCSV = "/v1/vendor-source-catalog-items/csv/import",

    // PO Shipments
    GetPOShipments = "/v1/purchase-orders/:purchaseOrderGuid/shipments",
    CreatePOShipment = GetPOShipments,
    GetPOShipment = "/v1/purchase-orders/:purchaseOrderGuid/shipments/:shipmentGuid",
    UpdatePOShipment = GetPOShipment,
    DeletePOShipment = GetPOShipment,
    FinalizePOShipment = "/v1/purchase-orders/:purchaseOrderGuid/shipments/:shipmentGuid/finalize",
    CreatePOShipmentItem = "/v1/purchase-orders/:purchaseOrderGuid/shipments/:shipmentGuid/items",
    UpdatePOShipmentItem = "/v1/purchase-orders/:purchaseOrderGuid/shipments/:shipmentGuid/items/:itemGuid",

    // Vehicles
    GetVehicles = "/v1/vehicles",
    CreateVehicle = GetVehicles,
    GetVehicle = "/v1/vehicles/:vehicleGuid",
    UpdateVehicle = GetVehicle,
    DeleteVehicle = GetVehicle,

    // Van-sell / DSD par levels + load sheet
    GetCustomerParLevels = "/v1/par_levels/customers",
    GetLoadSheetToday = "/v1/load_sheets/today",
    ConfirmLoadSheet = "/v1/load_sheets/today/confirm",
    UnloadLoadSheet = "/v1/load_sheets/today/unload",
    // Vehicle par editor (web admin only). The driver app reads vehicle par from
    // GET /v1/load_sheets/today and never calls these. GET + PUT share the path;
    // PUT is a MERGE (only the SKUs sent are written).
    GetVehicleParLevels = "/v1/par_levels/vehicles/:vehicleGuid",
    SetVehicleParLevels = GetVehicleParLevels,
    // Customer par editor (web admin only; the driver app pulls customer pars via the
    // delta GET above). GET + PUT share the path; PUT is a MERGE and par_qty 0 soft-deletes
    // the row (the app sees the tombstone on its next delta pull).
    GetCustomerParLevelsForVendor = "/v1/par_levels/customers/:vendorGuid",
    SetCustomerParLevelsForVendor = GetCustomerParLevelsForVendor,

    // Van-sell / DSD driver par-edit proposals (web-admin review)
    ListParProposals = "/v1/par_proposals",
    ApproveParProposal = "/v1/par_proposals/:guid/approve",
    RejectParProposal = "/v1/par_proposals/:guid/reject",

    // Van-sell / DSD end-of-day reconciliation.
    // Create (POST, driver app) and list (GET, web back-office) intentionally share the
    // collection path — separate members keep call sites greppable.
    CreateEodReconciliation = "/v1/eod_reconciliations",
    GetEodReconciliations = CreateEodReconciliation,

    // Tokens
    TokensGetAll = "/v1/tokens",
    TokensGetSupplierUsers = "/v1/tokens/supplier-users",
    TokensCreateSupplierUser = TokensGetSupplierUsers,
    TokensGetVendorUsers = "/v1/tokens/vendor-users",
    TokensCreateVendorUser = TokensGetVendorUsers,
    TokensGetVendorSourceUsers = "/v1/tokens/vendor-source-users",
    TokensCreateVendorSourceUser = TokensGetVendorSourceUsers,
    TokensCreateSupplierVendor = "/v1/tokens/supplier-vendors",
    TokensDelete = "/v1/tokens/:tokenGuid",
    TokensUpdateConfiguration = "/v1/tokens/:tokenGuid/configuration",
    TokensResendEmail = "/v1/tokens/:tokenGuid/resend-email",
    TokensSearch = "/v1/tokens/search",
    TokensGetSalesReps = "/v1/tokens/sales-reps",
    TokensParentVendor = "/v1/tokens/parent-vendor",
    TokensResetPassword = "/v1/tokens/:tokenGuid/reset-password",
    TokensGetRevoked = "/v1/tokens/revoked",
    TokensRestoreRevoked = "/v1/tokens/revoked/restore",
    TokensUpdateSettings = "/v1/tokens/:tokenGuid/settings",
    TokensGetUsage = "/v1/tokens/usage",
    TokensUpdateRecipient = "/v1/tokens/:tokenGuid/recipient",
    TokensEnablePlaceholder = "/v1/tokens/:tokenGuid/enable-placeholder",

    // File Uploads
    FileUploadGetSignedUrl = "/v1/files/signed-url",
    FileUploadCreate = "/v1/files",
    FileUploadGetDownloadUrl = "/v1/files/:attachmentGuid/download-url",
    FileUploadDelete = "/v1/files/:attachmentGuid",

    // Catalogs (REST)
    CatalogGetItemOptionsAssignmentTemplate = "/v1/catalogs/:catalogGuid/item-options/assignment-template",

    // Wine Industry
    WineExcelExport = "/v1/wine/:catalogGuid/excel-export",
    WineNYSLAExport = "/v1/wine/:catalogGuid/nysla-export",
    WineNYSLAAttributes = "/v1/wine/category/:categoryGuid/nysla-attributes",
    WineNYSLAAttributesBulk = "/v1/wine/catalog/:catalogGuid/nysla-attributes",

    // Addresses
    AddressesGet = "/v1/addresses",
    AddressCreate = AddressesGet,
    AddressUpdate = "/v1/addresses/:addressId",
    AddressDelete = AddressUpdate,
    AddressVerify = "/v1/addresses/verify",
    AddressDeliveryWindowsGet = "/v1/addresses/:addressId/delivery-windows",
    AddressDeliveryWindowCreate = AddressDeliveryWindowsGet,
    AddressDeliveryWindowUpdate = "/v1/addresses/:addressId/delivery-windows/:dayOfWeek",
    AddressDeliveryWindowDelete = AddressDeliveryWindowUpdate,
    AddressDefaultDeliveryWindowUpdate = "/v1/addresses/:addressId/default-delivery-window",
    AddressHasDeliveryWindow = "/v1/addresses/:addressId/has-delivery-window",

    // Delivery schedules (Delivery Deadlines feature)
    DeliverySchedulesGet = "/v1/delivery-schedules",
    DeliveryScheduleCreate = DeliverySchedulesGet,
    DeliveryScheduleGet = "/v1/delivery-schedules/:scheduleGuid",
    DeliveryScheduleUpdate = DeliveryScheduleGet,
    DeliveryScheduleDelete = DeliveryScheduleGet,
    DeliveryScheduleDayUpsert = "/v1/delivery-schedules/:scheduleGuid/days",
    DeliveryScheduleDayDelete = "/v1/delivery-schedules/:scheduleGuid/days/:dayGuid",
    VendorDeliveryScheduleAssign = "/v1/vendors/:vendorGuid/delivery-schedule",
    VendorDeliveryDeadlineReminders = "/v1/vendors/:vendorGuid/delivery-deadline-reminders",
    VendorDeliveryDeadlineSettingsGet = "/v1/vendors/:vendorGuid/delivery-deadline-settings",
    VendorDeliveryDeadlineUsersGet = "/v1/vendors/:vendorGuid/delivery-deadline-users",
    VendorUserDeliveryDeadlineOptOut = "/v1/vendors/:vendorGuid/users/:userGuid/delivery-deadline-opt-out",
    DeliveryDeadlineRemindersTrigger = "/v1/delivery-deadline-reminders/trigger",

    // Categories
    CategoriesGet = "/v1/categories",
    CategoryGetCategory = "/v1/categories/:categoryGuid",
    CategoryGetCatalogItems = "/v1/categories/:categoryGuid/catalog-items",
    CategoryGetHierarchy = "/v1/categories/:categoryGuid/hierarchy",
    SubCategoriesGet = "/v1/categories/:parentCategoryGuid/subcategories",

    // PDF Downloads
    PdfDownload = "/v1/pdf/:orderGuid/:pdfType",
    PdfBarcodeLabels = "/v1/pdf/barcode-labels",
    // PDF print profile (effective Pdf_Template + supplier branding) for on-device rendering (Enroute)
    PdfTemplateGet = "/v1/pdf_templates/:templateType",

    // QuickBooks Online
    QBOPushVendors = "/qbo/push-vendors",
    QBOReprocessOrderRepAssignments = "/qbo/reprocess-order-rep-assignments",
    QBOConnectVendors = "/qbo/connect-vendors",
    QBOPullCategories = "/qbo/pull-categories",
    QBODownloadCategories = "/qbo/download-categories",
    QBOInvoice = "/qbo/invoices/:qboEntityId",
    QBOInvoiceAttachments = "/qbo/invoices/:qboEntityId/attachments",
    QBOInvoiceAttachment = "/qbo/invoices/:qboEntityId/attachments/:attachmentGuid",
    QBOInvoiceAttachmentDownloadUrl = "/qbo/invoices/:qboEntityId/attachments/:attachmentGuid/download-url",
    QBOSearchCustomers = "/qbo/customers/search",

    // Routes (Templates)
    GetRouteTemplates = "/v1/routes",
    GetRoutes = "/v1/routes/list",

    // Cart
    CartBackfillCommissions = "/v1/cart/backfill-commissions",
    CartGetCart = "/v1/cart",
    CartGetInactive = "/v1/cart/inactive",
    CartCreateFromOrder = "/v1/cart/from-order",
    /** @deprecated Use CartCreatePaymentIntentForCart (cartGuid-scoped) instead. */
    CartCreatePaymentIntent = "/v1/cart/create-payment-intent",
    CartCompleteCheckout = "/v1/cart/complete-checkout",
    CartCopyItems = "/v1/cart/copy-items",
    CartGetActivePaymentIntent = "/v1/cart/active-payment-intent",
    CartCreatePaymentIntentForCart = "/v1/cart/:cartGuid/create-payment-intent",
    CartConfirmPayment = "/v1/cart/:cartGuid/confirm-payment",
    CartGetStatus = "/v1/cart/:cartGuid/status",
    CartRetryPayment = "/v1/cart/:cartGuid/retry-payment",
    CartCancel = "/v1/cart/:cartGuid/cancel",
    CartGetByGuid = "/v1/cart/:cartGuid",
    CartAddItem = "/v1/cart/items",
    CartBulkAddItems = "/v1/cart/items/bulk",
    CartUpdateItem = "/v1/cart/items/:cartItemGuid",
    CartDeleteItem = CartUpdateItem,

    // Dashboards
    DashboardLoad = "/v1/dashboard/load",
    DashboardProcess = "/v1/dashboard/process",
    DashboardGetDashboards = "/v1/dashboards",
    DashboardDownload = "/v1/dashboard/download",
    DashboardGetWidgetData = "/v1/dashboard/widget-data",
    DashboardRefreshWidgetData = "/v1/dashboard/refresh-widget-data",
    MobileDashboardGetConfig = "/v1/mobile-dashboard/config",
    MobileDashboardUpdateConfig = MobileDashboardGetConfig,
    MobileDashboardResetConfig = "/v1/mobile-dashboard/config/reset",

    // Bulk Image Processing (Internal Lambda API)
    BulkImageZipAttachmentDetail = "/api/internal/bulk-image/zip-attachment-detail",
    BulkImageSkuLookup = "/api/internal/bulk-image/sku-lookup",
    BulkImageCreateAttachment = "/api/internal/bulk-image/attachment",
    BulkImageUpdateAttachment = "/api/internal/bulk-image/attachment/:id",

    // FastBound Account CRUD
    FastBoundGetAccounts = "/fastbound/accounts",
    FastBoundCreateAccount = FastBoundGetAccounts,
    FastBoundGetAccountById = "/fastbound/accounts/:accountId",
    FastBoundUpdateAccount = FastBoundGetAccountById,
    FastBoundDeleteAccount = FastBoundGetAccountById,
    FastBoundTestAccountConnection = "/fastbound/accounts/:accountId/test-connection",

    // FastBound Connection Test
    FastBoundTestConnection = "/fastbound/test-connection",

    // FastBound API Account
    FastBoundGetAccount = "/fastbound/account",

    // FastBound Items
    FastBoundGetItems = "/fastbound/items",
    FastBoundGetItemById = "/fastbound/items/:id",
    FastBoundEditItem = FastBoundGetItemById,
    FastBoundDeleteItem = "/fastbound/items/:id/delete",
    FastBoundSetItemExternalId = "/fastbound/items/:id/set-external-id",
    FastBoundSetItemExternalIds = "/fastbound/items/set-external-ids",
    FastBoundUndisposeItem = "/fastbound/items/:id/undispose",
    FastBoundGetDisposedItems = "/fastbound/items/disposed",

    // FastBound Contacts
    FastBoundGetContacts = "/fastbound/contacts",
    FastBoundCreateContact = FastBoundGetContacts,
    FastBoundGetContactById = "/fastbound/contacts/:id",
    FastBoundEditContact = FastBoundGetContactById,
    FastBoundDeleteContact = FastBoundGetContactById,
    FastBoundMergeContacts = "/fastbound/contacts/merge",
    FastBoundCreateContactLicense = "/fastbound/contacts/:id/licenses",
    FastBoundEditContactLicense = "/fastbound/contacts/:id/licenses/:licenseId",
    FastBoundDeleteContactLicense = FastBoundEditContactLicense,

    // FastBound Acquisitions
    FastBoundGetAcquisitions = "/fastbound/acquisitions",
    FastBoundCreateAcquisition = FastBoundGetAcquisitions,
    FastBoundGetAcquisitionById = "/fastbound/acquisitions/:id",
    FastBoundEditAcquisition = FastBoundGetAcquisitionById,
    FastBoundDeleteAcquisition = FastBoundGetAcquisitionById,
    FastBoundCreateAcquisitionItem = "/fastbound/acquisitions/:id/items",
    FastBoundCreateAcquisitionItems = "/fastbound/acquisitions/:id/items/multiple",
    FastBoundEditAcquisitionItem = "/fastbound/acquisitions/:id/items/:itemId",
    FastBoundDeleteAcquisitionItem = FastBoundEditAcquisitionItem,
    FastBoundCommitAcquisition = "/fastbound/acquisitions/:id/commit",
    FastBoundCreateAndCommitAcquisition = "/fastbound/acquisitions/create-and-commit",
    FastBoundCreateAsPendingAcquisition = "/fastbound/acquisitions/create-as-pending",

    // FastBound Dispositions
    FastBoundGetDispositions = "/fastbound/dispositions",
    FastBoundCreateDisposition = FastBoundGetDispositions,
    FastBoundGetDispositions4473s = "/fastbound/dispositions/only-4473s",
    FastBoundGetDispositionById = "/fastbound/dispositions/:id",
    FastBoundGetDispositionByExternalId = "/fastbound/dispositions/by-external-id/:externalId",
    FastBoundGetLocalDisposition = "/fastbound/dispositions/local/:id",
    FastBoundEditDisposition = FastBoundGetDispositionById,
    FastBoundDeleteDisposition = FastBoundGetDispositionById,
    FastBoundCreateNfaDisposition = "/fastbound/dispositions/nfa",
    FastBoundCreateTheftLossDisposition = "/fastbound/dispositions/theft-loss",
    FastBoundCreateDestroyedDisposition = "/fastbound/dispositions/destroyed",
    FastBoundGetDispositionItems = "/fastbound/dispositions/:id/items",
    FastBoundAddDispositionItems = FastBoundGetDispositionItems,
    FastBoundEditDispositionItemPrice = "/fastbound/dispositions/:id/items/edit-price/:itemId",
    FastBoundRemoveDispositionItem = "/fastbound/dispositions/:id/items/remove/:itemId",
    FastBoundCommitDisposition = "/fastbound/dispositions/:id/commit",
    FastBoundCreateAndCommitDisposition = "/fastbound/dispositions/create-and-commit",
    FastBoundCreateDispositionForOrder = "/fastbound/dispositions/create-for-order",
    FastBoundCreateAsPendingDisposition = "/fastbound/dispositions/create-as-pending",
    FastBoundLockDisposition = "/fastbound/dispositions/lock/:id",
    FastBoundGetOrderDispositions = "/fastbound/dispositions/order/:orderId",

    // FastBound Inventory
    FastBoundBulkVerifyInventory = "/fastbound/inventory/bulk-verify",

    // FastBound SmartLists
    FastBoundGetSmartList = "/fastbound/smart-lists/:listName",

    // FastBound Webhooks
    FastBoundGetWebhookEvents = "/fastbound/webhooks/events",
    FastBoundGetWebhook = "/fastbound/webhooks/:name",
    FastBoundCreateWebhook = "/fastbound/webhooks",
    FastBoundEditWebhook = FastBoundGetWebhook,
    FastBoundDeleteWebhook = FastBoundGetWebhook,
    FastBoundReceiveWebhook = "/fastbound/webhooks/receive",

    // FastBound Downloads
    FastBoundDownloadBoundBook = "/fastbound/downloads/bound-book",

    // FastBound Sync & Queue
    FastBoundSyncAcquisitions = "/fastbound/sync/acquisitions",
    FastBoundSyncContacts = "/fastbound/sync/contacts",
    FastBoundSyncItems = "/fastbound/sync/items",
    FastBoundGetConfig = "/fastbound/config",
    FastBoundUpdateConfig = FastBoundGetConfig,
    FastBoundGetDashboard = "/fastbound/dashboard",
    FastBoundGetQueueStatus = "/fastbound/queue/status",
    FastBoundCancelQueueItem = "/fastbound/queue/:queueId/cancel",
    FastBoundRetryQueueItem = "/fastbound/queue/:queueId/retry",

    // FastBound Error Logs
    FastBoundGetErrorLogs = "/fastbound/error-logs",
    FastBoundDismissAllErrorLogs = "/fastbound/error-logs/dismiss-all",
    FastBoundGetErrorLogById = "/fastbound/error-logs/:errorId",
    FastBoundDismissErrorLog = "/fastbound/error-logs/:errorId/dismiss",
    FastBoundRetryErrorLog = "/fastbound/error-logs/:errorId/retry",

    // FastBound Pending Serials (Manual Catalog Assignment)
    FastBoundGetPendingSerials = "/fastbound/serials/pending",
    FastBoundAssignSerial = "/fastbound/serials/:serialId/assign",
    FastBoundBulkAssignSerials = "/fastbound/serials/bulk-assign",
    FastBoundDismissSerials = "/fastbound/serials/dismiss",
    FastBoundUndismissSerials = "/fastbound/serials/undismiss",

    // Unanet
    UnanetSearchProjects = "/v1/unanet/projects",
    UnanetQueueJournalEntry = "/v1/unanet/journal-entries/queue",
    UnanetQueueJournalEntryBulk = "/v1/unanet/journal-entries/queue/bulk",
    UnanetProcessQueue = "/v1/unanet/journal-entries/process-queue",
    UnanetGetQueueStatus = "/v1/unanet/journal-entries/queue/status",
    UnanetHealth = "/v1/unanet/health",
    UnanetTestConnection = "/v1/unanet/settings/test-connection",
    UnanetGetLegalEntities = "/v1/unanet/legal-entities",
    UnanetGetOrganizations = "/v1/unanet/organizations",
    UnanetGetAccounts = "/v1/unanet/accounts",
    UnanetGetExpenseTypes = "/v1/unanet/expense-types",
    UnanetGetProjectTypes = "/v1/unanet/project-types",
    UnanetUpdateVendorProject = "/v1/unanet/vendors/:vendorGuid/project",
    UnanetUpdateVendorExpenseType = "/v1/unanet/vendors/:vendorGuid/expense-type",
    UnanetGetProjectTasks = "/v1/unanet/projects/:projectKey/tasks",
    UnanetGetVendorTaskMappings = "/v1/unanet/vendors/:vendorGuid/task-mappings",
    UnanetUpsertVendorTaskMapping = UnanetGetVendorTaskMappings,
    UnanetDeleteVendorTaskMapping = "/v1/unanet/vendors/:vendorGuid/task-mappings/:categoryGuid",

    // Unanet Account Mappings
    UnanetGetAccountMappings = "/v1/unanet/account-mappings/:catalogGuid",
    UnanetUpsertAccountMapping = "/v1/unanet/account-mappings/:categoryGuid",
    UnanetDeleteAccountMapping = UnanetUpsertAccountMapping,

    // Unanet Dashboard
    UnanetDashboardStats = "/v1/unanet/dashboard/stats",
    UnanetDashboardActivityLog = "/v1/unanet/dashboard/activity-log",
    UnanetGetQueueItemDetail = "/v1/unanet/journal-entries/queue/:queueGuid",
    UnanetRetryQueueItem = "/v1/unanet/journal-entries/queue/:queueGuid/retry",
    UnanetResolveQueueItem = "/v1/unanet/journal-entries/queue/:queueGuid/resolve",

    // Unanet Sync Log Detail
    UnanetGetSyncLogDetail = "/v1/unanet/sync-logs/:syncLogGuid",

    // Unanet Order Sync Status
    UnanetOrderSyncStatus = "/v1/unanet/orders/:orderGuid/sync-status",

    // Catchwerks
    CatchwerksBulkPricing = "/v1/catchwerks/bulk-pricing",
    CatchwerksEnrollment = "/v1/catchwerks/enrollments",
    CatchwerksBillingCharge = "/v1/catchwerks/billing/charge",
    CatchwerksBillingAlert = "/v1/catchwerks/billing/alert",

    // Production Steps
    ProductionStepsGetAll = "/v1/production/steps",
    ProductionStepsCreate = ProductionStepsGetAll,
    ProductionStepsUpdate = "/v1/production/steps/:productionStepGuid",
    ProductionStepsDelete = ProductionStepsUpdate,

    // Production Log
    ProductionLogCreate = "/v1/production/log",
    ProductionLogGetBySerial = "/v1/production/log/:serialGuid",

    // Production Workflow
    ProductionAdvance = "/v1/production/advance",
    ProductionSerials = "/v1/production/serials",
    ProductionSerialHistory = "/v1/production/serial/:serialId/history",
    ProductionDashboard = "/v1/production/dashboard",
    ProductionWorkflows = "/v1/production/workflows",
    ProductionWorkflow = "/v1/production/workflows/:workflowId",
    ProductionWorkflowSteps = "/v1/production/workflows/:workflowId/steps",
    ProductionWorkflowStep = "/v1/production/workflows/steps/:stepId",

    // Login message (required acknowledgment)
    GetActiveLoginMessage = "/v1/login-message/active",
    AcknowledgeLoginMessage = "/v1/login-message/acknowledge",
    GetLoginMessageAcknowledgments = "/v1/login-message/acknowledgments",

    // Ecommerce favorites (per customer account)
    FavoritesGet = "/v1/favorites",
    FavoritesGetIds = "/v1/favorites/ids",
    FavoritesAdd = FavoritesGet,
    FavoritesBulkAdd = "/v1/favorites/bulk",
    FavoritesRemove = "/v1/favorites/:catalogItemGuid",
}

export default RestEndpointsEnum;
